import { CrmField } from '../types';

/**
 * Determines if a CRM field can be used in a filter locator expression.
 * Only primitive types like boolean, picklist, string and numbers are supported.
 */
export function isFilterable(field: CrmField): boolean {
  const filterableTypes = new Set([
    'boolean',
    'picklist',
    'string',
    'double',
    'integer',
    'currency',
  ]);
  return filterableTypes.has(field.type);
}

export type AdaptedInputType = 'boolean' | 'picklist' | 'text';

/**
 * Gets the type of input that should be rendered for a CRM field.
 */
export function getAdaptedInputType(field: CrmField): AdaptedInputType {
  if (field.type === 'boolean') return 'boolean';
  if (field.type === 'picklist') return 'picklist';
  return 'text';
}

/**
 * Determines if a CRM field can be used for sorting when building a positional locator.
 * Text area and multipicklist fields are excluded.
 */
export function isSortable(field: CrmField): boolean {
  const nonSortableTypes = new Set(['textarea', 'multipicklist']);
  return !nonSortableTypes.has(field.type);
}
